import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getVirtualsOnVotingPhase } from '../api/virtual.api';

const useVirtualVotingPhase = () => {
  const [hasVirtualOnVotingPhase, setHasVirtualOnVotingPhase] =
    useState<Boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { data: virtuals } = useQuery({
    queryKey: ['virtualsOnVotingPhase1'],
    queryFn: () => getVirtualsOnVotingPhase(),
  });

  useEffect(() => {
    if (virtuals && virtuals?.length > 0) {
      setHasVirtualOnVotingPhase(true);
    }
  }, [virtuals]);

  return { hasVirtualOnVotingPhase, isLoading };
};

export default useVirtualVotingPhase;
